import type {
  AccessAndJobQuery,
  AccessAndJobQueryVariables,
} from 'src/App/AppPageBlock/graphql/hirer-types.generated';

import hirerGraphqlClient from './client';
import { query } from './schema/queryAccessAndJob';

const fetchAccessAndJob = async (variables: AccessAndJobQueryVariables) => {
  const { data } = await hirerGraphqlClient.query<
    AccessAndJobQuery,
    AccessAndJobQueryVariables
  >({
    variables,
    query,
    fetchPolicy: 'cache-first',
  });
  if (data === null) {
    throw new Error('error in rendering access and job information');
  }

  return data;
};

export default fetchAccessAndJob;
